import React, { useContext, useEffect, useState } from 'react';
import '../css/login.css';
import { AuthContext } from '../auth/AuthContext';
import { useForm } from '../hooks/useForm';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { fetchSinToken } from '../api/fetch';
import toast, { Toaster } from 'react-hot-toast';
const baseUrl = process.env.REACT_APP_API;

export const Login = () => {
    const { login } = useContext(AuthContext);
    const [values, handleInputChange, setFormValue] = useForm({
        user: '',
        password: '',
        rememberme: false,
    });
    const [theme, setTheme] = useState({
        imagen_login: 'https://getwallpapers.com/wallpaper/small-retina/a/6/c/35748.jpg',
        logo: '',
    });
    useEffect(() => {
        setUser();
    }, []);
    useEffect(() => {
        getInfo();
    }, []);
    const getInfo = async () => {
        const r = await fetchSinToken('theme/login');
        if (r.ok) setTheme({ ...r.data });
    };
    const setUser = () => {
        const user = localStorage.getItem('agente');
        if (user) {
            setFormValue((values) => ({
                ...values,
                user,
                rememberme: true,
            }));
        }
    };
    const toggleCheck = () => {
        setFormValue({
            ...values,
            rememberme: !values.rememberme,
        });
    };
    const onSubmit = async (ev) => {
        ev.preventDefault();

        values.rememberme ? localStorage.setItem('agente', values.user) : localStorage.removeItem('agente');

        const { user, password } = values;

        const ok = await login(user, password);
        //
        if (!ok) {
            toast.error('Error, verifica que tus datos sean correctos!');
        }
    };

    const todoOk = () => {
        return values.user.length > 0 && values.password.length > 0 ? true : false;
    };
    return (
        <div
            className="flex-container login-cover"
            style={{
                backgroundImage: `url(${theme.imagen_login})`,
            }}>
            <div className="d-block p-4 rounded shadow mx-auto text-center ">
                <form onSubmit={onSubmit}>
                    {' '}
                    <img
                        src={`${
                            theme.logo
                                ? baseUrl + theme.logo
                                : 'https://www.runtimewifi.mx/static/media/logo.cb32f1fe.png'
                        }`}
                        alt="RTW"
                        style={{ width: '300px' }}
                        className="rounded mx-auto d-block "
                    />
                    {/* Email input */}
                    <div className="form-outline mb-4">
                        <label className="form-label text-white" htmlFor="form2Example1">
                            Usuario
                        </label>{' '}
                        <input
                            type="text"
                            id="form2Example1"
                            placeholder="Usuario"
                            name="user"
                            value={values.user}
                            onChange={handleInputChange}
                            className="form-control"
                        />
                    </div>
                    {/* Password input */}
                    <div className="form-outline mb-4">
                        <label className="form-label text-white" htmlFor="form2Example2">
                            Contraseña
                        </label>{' '}
                        <input
                            type="password"
                            id="form2Example2"
                            value={values.password}
                            onChange={handleInputChange}
                            name="password"
                            className="form-control"
                        />
                    </div>
                    {/* 2 column grid layout for inline styling */}
                    <div className="row mb-4">
                        <div className="col d-flex justify-content-center">
                            {/* Checkbox */}
                            <div className="form-check">
                                <input
                                    onClick={() => toggleCheck()}
                                    className="form-check-input"
                                    type="checkbox"
                                    name="rememberme"
                                    checked={values.rememberme}
                                    id="form2Example31"
                                />
                                <label className="form-check-label text-white" htmlFor="form2Example31">
                                    Recordar
                                </label>
                            </div>
                        </div>
                    </div>
                    {/* Submit button */}
                    <button type="submit" disabled={!todoOk()} className="btn btn-primary btn-block mb-4">
                        Ingresar al Administrador
                    </button>
                </form>{' '}
                <Toaster />
            </div>
        </div>
    );
};
